import axios from 'axios'

export default {
  getGradeLevels ({ commit }) {
    commit('getGradeLevelsRequest')
    let url = `/api/grade-level/?limit=0`

    return axios
      .get(url)
      .then(function (response) {
        commit('getGradeLevelsSuccess', response.data)
        return response
      })
      .catch(function (error) {
        commit('getGradeLevelsFailure', error)
        throw error
      })
  }
}
